export class User {
    Id: string;
    Email: string;
    Password: string;
    ConfirmPassword: string;
    FirstName: string;
    LastName: string;
    Status: string;
    EmailConfirmed: string
};

export class Access {
  Groups: string;
  IsAdmin: boolean;
}

export class Role {
  constructor(public UserId: string, public RoleId: string) {}

}

export class UserAccess extends User {
   Groups: string;
   Roles: Role[];
   RoleNames: string[];
}

